import { useLayoutEffect, useRef } from "react";

const focusable = 'button:not(:disabled),a[href],input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex="0"]';
export default function useBookRevealFocus(root, close, navigation) {
	const latest = useRef({ close, navigation });
	latest.current = { close, navigation };
	useLayoutEffect(() => {
		const opener = document.activeElement;
		const node = root.current;
		const background = document.getElementById("root");
		const oldInert = background?.getAttribute("inert");
		const oldHidden = background?.getAttribute("aria-hidden");
		const oldOverflow = document.body.style.overflow;
		const oldPadding = document.body.style.paddingRight;
		const scrollbar = window.innerWidth - document.documentElement.clientWidth;
		document.body.style.overflow = "hidden";
		if (scrollbar > 0 && document.documentElement.clientWidth > 0) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight || 0) + scrollbar}px`;
		background?.setAttribute("inert", "");
		background?.setAttribute("aria-hidden", "true");
		const targets = () => Array.from(node.querySelectorAll(focusable)).filter((item) => !item.closest('[aria-hidden="true"],[hidden]') && getComputedStyle(item).display !== "none");
		const first = () => targets()[0] || node;
		first().focus({ preventScroll: true });
		const keydown = (event) => {
			if (!node.contains(document.activeElement)) return;
			if (event.key === "Escape") { event.preventDefault(); latest.current.close(); }
			if (event.key === "Tab") {
				const items = targets(), last = items[items.length - 1];
				if (event.shiftKey && (document.activeElement === first() || document.activeElement === node)) { event.preventDefault(); last?.focus(); }
				else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first().focus(); }
			}
			if (event.altKey || event.metaKey || event.ctrlKey || event.target.closest('input,select,textarea,a,[data-reveal-actions]')) return;
			const nav = latest.current.navigation;
			if (event.key === "ArrowLeft" && nav.position > 0) { event.preventDefault(); nav.onPrevious?.(); }
			if (event.key === "ArrowRight" && nav.position < nav.count - 1) { event.preventDefault(); nav.onNext?.(); }
		};
		const containFocus = (event) => { if (!node.contains(event.target)) first().focus({ preventScroll: true }); };
		document.addEventListener("keydown", keydown);
		document.addEventListener("focusin", containFocus);
		return () => {
			document.removeEventListener("keydown", keydown);
			document.removeEventListener("focusin", containFocus);
			document.body.style.overflow = oldOverflow;
			document.body.style.paddingRight = oldPadding;
			if (background) {
				if (oldInert === null) background.removeAttribute("inert"); else background.setAttribute("inert", oldInert);
				if (oldHidden === null) background.removeAttribute("aria-hidden"); else background.setAttribute("aria-hidden", oldHidden);
			}
			if (opener?.isConnected && !document.querySelector('.p-dialog,.p-sidebar-active')) opener.focus({ preventScroll: true });
		};
	}, [root]);
}
